// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__4Nimt","active":"ProgressBar_active__9d0HR","completed":"ProgressBar_completed__5siMS"};